import { attr, belongsTo } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const Addon = ApplicationRecord.extend({
  static: {
    jsonapiType: 'addons',
  },
  attrs: {
    name: attr(),
    priceWith: attr(),
    priceWithout: attr(),
    isElementary: attr(),
    // ⚠️ ONE COLUMN, TWO NAMES. `onGiftsPage` says what it decides -- does this
    // add-on appear on the Announcements & Gifts grid. `isHoliday` is the
    // database column's original name, kept because carts and sheets built
    // before the rename still carry it (see DisplayableSheet, CartItem
    // DetailedView) and a customer's already-loaded page still sends it.
    isHoliday: attr(),
    onGiftsPage: attr(),
    isSenior: attr(),
    popup: attr(),
    cssName: attr(),
    // Which section of the Announcements & Gifts page this product sits under.
    // Resolved SERVER-side (Addon#gift_category) so the grouping has one
    // implementation: a product re-filed on /admin/addons moves without a
    // deploy, and the front end sorts sections on the served position rather
    // than trusting a hash's key order to survive serialization.
    giftCategory: attr(),
    giftCategoryLabel: attr(),
    giftCategoryPosition: attr(),
    createdAt: attr(),
    updatedAt: attr(),
    imageCount: attr(),
    component: belongsTo(),
    description: attr(),
    tagline: attr(),
    // The one-line spec under the name on the shelf ("Set of 25"). Its own
    // field because `description` and `tagline` are entered inconsistently --
    // see Api::AddonResource. Blank renders no line at all.
    detailLine: attr(),
    quantity: attr(),
    imageUrl: attr(),
    backImageUrl: attr(),
    blankImageUrl: attr(),
    horizImageUrl: attr(),
    backgroundSelection: attr(),
  },
});

export default Addon;
